import { useEffect } from 'react';
import useTrackTabChange from './useTrackTabChange';
import { ensureFreshToken, scheduleProactiveRenewal, stopProactiveRenewal } from 'services/tokenManager';

// Keeps the access token continuously fresh for the whole authenticated session.
// The heavy lifting (single-flight silent renewal + precise pre-expiry
// scheduling) lives in tokenManager; this hook just wires it to the React
// lifecycle and re-tops-up when the user returns to the tab (setTimeout can be
// throttled while a tab is backgrounded).
const useTokenRenewal = () => {
    const isTabVisible = useTrackTabChange();

    useEffect(() => {
        if (!localStorage.getItem('accessToken')) {
            return;
        }
        // Immediate top-up in case the token expired while the tab was hidden,
        // then (re)arm the precise pre-expiry renewal timer.
        ensureFreshToken().catch(() => null);
        scheduleProactiveRenewal();

        return () => stopProactiveRenewal();
    }, [isTabVisible]);
};

export default useTokenRenewal;
